import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M21 21H3V10.875H8.625V15.938H15.375V10.875H21V21ZM15.375 8.063H8.625V3H15.375V8.062V8.063Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Unsplash"
);
